<template>
  <h6 class="fw-bold border-bottom pb-2 mb-3 mt-3">
    <i v-if="icon" :class="['fa', icon, 'me-1', 'text-secondary']"></i>
    {{ label }}
    <span v-if="required" class="text-danger">*</span>
  </h6>
</template>

<script>
export default {
  name: "SectionHeader",

  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>